<template>
  <div>
    <ts-loading-banner :loading="student_search">
      <div class="row">
        <div class="col-md-6">
          <form>
            <fieldset>
              <legend>{{ $t('thesis.member') }}</legend>
              <div class="col-md-12">
                <div class="overflow-auto" id="student-table-container">
                  <table class="table table-hover" id="student-table">
                    <thead>
                      <tr>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.no') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.cardNumber') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.studentName') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.sex') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.major') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.level') }}
                        </th>
                        <th class="ts-whitespace-no-wrap">
                          {{ $t('thesis.promotion') }}
                        </th>
                      </tr>
                      <tr>
                        <th colspan="7">
                          <input
                            type="text"
                            class="form-control"
                            v-model="student_search_value"
                            :readonly="model.class_id == ''"
                            :placeholder="$t('studentEnrollment.searchStudent')"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(student, index) in studentLists"
                        :key="index"
                        @dblclick="selectStudent(student)"
                      >
                        <td class="ts-whitespace-no-wrap text-center">
                          {{ index + 1 }}
                        </td>

                        <td class="ts-whitespace-no-wrap">
                          {{ student.card_number ? student.card_number : null }}
                        </td>
                        <td class="ts-whitespace-no-wrap">
                          {{ student.full_name_en }}
                        </td>
                        <td class="ts-whitespace-no-wrap">
                          {{ student.gender }}
                        </td>
                        <td class="ts-whitespace-no-wrap">
                          {{ student.acps_name_foreign }}
                        </td>
                        <td class="ts-whitespace-no-wrap">
                          {{ student.level_name_foreign }}
                        </td>
                        <td class="ts-whitespace-no-wrap text-center">
                          {{ student.promotion }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="col-md-6">
          <form>
            <fieldset>
              <legend>{{ $t('thesis.thesisRegistrationList') }}</legend>
              <div class="overflow-auto" id="student-table-container">
                <table class="table table-hover" id="student-table">
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">No</th>

                      <th>
                        {{ $t('thesis.leader') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('thesis.cardNumber') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('thesis.studentName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('thesis.sex') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('thesis.major') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('thesis.level') }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width: 7%"
                      >
                        {{ $t('thesis.promotion') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width: 3%">
                        {{ $t('thesis.actions') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(list, index) in model.student_id_list"
                      :key="index"
                    >
                      <td class="ts-whitespace-no-wrap text-center">
                        {{ index + 1 }}
                      </td>

                      <td class="ts-py-2 ts-px-3">
                        <div>
                          <input
                            type="checkbox"
                            v-model="list.is_leader"
                            :id="index"
                            @click="setDefault(list)"
                          />
                          <label :for="index"></label>
                        </div>
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).card_number
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).full_name_en
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).gender
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).acps_name_foreign
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).level_name_foreign
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap text-center">
                        {{
                          studentFilter({
                            studentId: list.student_id
                          })
                            ? studentFilter({
                                studentId: list.student_id
                              }).promotion
                            : ''
                        }}
                      </td>

                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click="removeStudent(list)"
                          ><i class="fa fa-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce, orderBy } from 'lodash'

export default {
  name: 'studentListEnrollment',
  props: ['value'],
  data () {
    return {
      student_search_value: '',
      student_search: false,
      is_leader: false,
      studentResources: [],
      studentEnrollments: [],
      model: {}
    }
  },
  created () {
    this.model = this.value
    this.setEdit()
  },
  computed: {
    ...mapState('thesis', ['editData']),
    studentFilter:
      vm =>
      ({ studentId }) => {
        if (studentId == undefined) return undefined
        return vm.studentEnrollments.find(en => en.student_id === studentId)
      },
    studentLists: function () {
      return this.studentResources.filter(
        s =>
          !_.includes(
            this.model.student_id_list.map(stud => stud.student_id),
            s.student_id
          )
      )
    },
    ...mapState('thesis', ['editData'])
  },
  methods: {
    ...mapActions('thesis', ['getStudent']),
    fetStudentList (params) {
      this.student_search = true
      this.getStudent(params)
        .then(response => {
          let data = []
          response.data.forEach(el => {
            let { level, sub_program, ...resource } = el
            data.push({ ...level, ...sub_program, ...resource })
          })

          this.studentResources = orderBy(
            data,
            ['level_name_foreign', 'acps_name_foreign', 'card_number'],
            ['desc']
          )
        })
        .finally(() => {
          this.student_search = false
        })
    },
    selectStudent (student) {
      this.model.student_id_list.unshift({
        student_id: student.student_id,
        is_main_class: true,
        is_leader: false
      })
      this.studentEnrollments.unshift(student)
    },
    removeStudent (student) {
      this.model.student_id_list.splice(
        this.model.student_id_list.indexOf(student),
        1
      )
      this.studentEnrollments.splice(
        this.studentEnrollments.indexOf(
          this.studentEnrollments.find(s => s.student_id == student.student_id)
        ),
        1
      )
    },
    setEdit () {
      if (this.$route.params.id) {
        this.editData.thesis_registration_members.forEach(el => {
          this.studentEnrollments.push(el)
        })
      }
    },
    setDefault (list) {
      this.model.student_id_list
        .filter(el => el.is_leader == true)
        .forEach(el => (el.is_leader = false))
    }
  },
  watch: {
    'model.class_id': function () {
      this.studentResources = []
      this.$refs.studentList = []
      this.student_search_value = ''
    },
    student_search_value: debounce(function (value) {
      if (value) {
        this.fetStudentList({
          search: value,
          page: -1,
          filter: {
            in_enrollmented_class: this.model.class_id
          }
        })
      } else {
        this.fetStudentList({
          perPage: 20,
          filter: {
            in_enrollmented_class: this.model.class_id
          }
        })
      }
    }, 500)
  }
}
</script>
<style lang="css" scoped>
#enroll {
  height: 70vh;
}

#student-table-container {
  height: 40vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#student-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#student-table > tbody > tr > td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
.none-border {
  border: none;
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
  background: #f2f3f4;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
